export const ledgerAttachmentsCmpDomId = `ledgerAttachments` // inside rental history form
